// extracted by mini-css-extract-plugin
export default {"bounce":"N_dm","loading":"N_dn","logo-mark-bounce-right":"N_dp","logo-mark-bounce-left":"N_dq"};